import React, { useState, useRef, useEffect } from "react";
import {
  FaSpa,
  FaSun,
  FaEnvelope,
  FaUser,
  FaEllipsisH,
  FaDumbbell,
  FaHotel,
  FaHeadphones,
  FaHandsHelping,
  FaBolt,
} from "react-icons/fa";
import { MdGraphicEq } from "react-icons/md";
import { GiMeditation, GiFruitBowl } from "react-icons/gi";
import { useLocation, Link } from "react-router-dom";
import wellLogo from "../assets/well_icon.png";
import "./NavBar.css";

export default function NavBar() {
  const location = useLocation();
  const [showTabBar, setShowTabBar] = useState(false);
  const moreBtnRef = useRef<HTMLButtonElement>(null);
  const tabBarRef = useRef<HTMLDivElement>(null);

  // Hide tab bar if click outside
  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (
        tabBarRef.current &&
        !tabBarRef.current.contains(e.target as Node) &&
        moreBtnRef.current &&
        !moreBtnRef.current.contains(e.target as Node)
      ) {
        setShowTabBar(false);
      }
    }
    if (showTabBar) {
      window.addEventListener("mousedown", handleClick);
      return () => window.removeEventListener("mousedown", handleClick);
    }
  }, [showTabBar]);

  // Helper to match paths
  const isActive = (path: string) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="wbn-navbar">
      <div className="wbn-navbar-logo">
        <img src={wellLogo} alt="WellBnB Logo" className="wbn-logo-img" />
        <span className="wbn-navbar-title">WellBnB<span style={{fontSize: '0.6em', verticalAlign: 'super'}}>™</span></span>
      </div>
      <div className="wbn-navbar-links">
        {/* First Row */}
        <div className="wbn-navbar-row">
          <Link
            to="/"
            className={`wbn-navbar-btn${
              isActive("/") ? " wbn-navbar-btn--active" : ""
            }`}
          >
            <FaSpa /> WELLBNB
          </Link>
          <Link
            to="/travel"
            className={`wbn-navbar-btn${
              isActive("/travel") ? " wbn-navbar-btn--active" : ""
            }`}
          >
            <FaHotel /> TRAVEL
          </Link>
          <Link
            to="/retreats"
            className={`wbn-navbar-btn${
              isActive("/retreats") ? " wbn-navbar-btn--active" : ""
            }`}
          >
            <FaSun /> RETREATS
          </Link>
        </div>
        
        {/* Second Row */}
        <div className="wbn-navbar-row">
          <Link
            to="/practice"
            className={`wbn-navbar-btn${
              isActive("/practice") ? " wbn-navbar-btn--active" : ""
            }`}
          >
            <FaBolt /> PRACTICE
          </Link>
          <Link
            to="/profile"
            className={`wbn-navbar-btn${
              isActive("/profile") ? " wbn-navbar-btn--active" : ""
            }`}
          >
            <FaUser /> PROFILE
          </Link>
          <button
            className="wbn-navbar-btn"
            ref={moreBtnRef}
            onClick={() => setShowTabBar((v) => !v)}
            aria-haspopup="true"
            aria-expanded={showTabBar}
          >
            <FaEllipsisH /> MORE
          </button>
        </div>
      </div>
      {showTabBar && (
        <div className="wbn-tabbar-popup" ref={tabBarRef}>
          <Link className="wbn-tabbar-link" to="/inbox">
            <FaEnvelope /> INBOX
          </Link>
          <Link className="wbn-tabbar-link" to="/concierge">
            <FaSpa /> CONCIERGE
          </Link>
          <Link className="wbn-tabbar-link" to="/fitness">
            <FaDumbbell /> FITNESS
          </Link>
          <Link className="wbn-tabbar-link" to="/yoga">
            <GiMeditation /> YOGA
          </Link>
          <Link className="wbn-tabbar-link" to="/vibe">
            <MdGraphicEq /> VIBE
          </Link>
          <Link className="wbn-tabbar-link" to="/well">
            <GiFruitBowl /> WELL
          </Link>
          <Link className="wbn-tabbar-link" to="/playlists">
            <FaHeadphones /> PLAYLISTS
          </Link>
          <Link className="wbn-tabbar-link" to="/support">
            <FaHandsHelping /> SUPPORT
          </Link>
        </div>
      )}
    </nav>
  );
}
